export enum INPUT_VARIANT {
  LOGIN_INPUT = 'login input',
  ERROR_INPUT = 'error input',
  DEFAULT_INPUT = 'default',
}
